import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ExportAsConfig, ExportAsService, SupportedExtensions } from 'ngx-export-as';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { SwalService } from 'projects/b2c/src/app/core/services/swal.service';
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';
import { SubSink } from 'subsink';
import { FlightService } from '../../flight.service';

@Component({
  selector: 'app-mobile-voucher',
  templateUrl: './mobile-voucher.component.html',
  styleUrls: ['./mobile-voucher.component.scss']
})
export class MobileVoucherComponent implements OnInit {

  @ViewChild('print_voucher', { static: false }) print_voucher: ElementRef;
    srcUrl: string = "";
    public browserRefresh: boolean;
    currentUser: any;
    todayDate = new Date();
    confirmedData: any;
    contact: any;
    airline_logo: string = '';
    private subSunk = new SubSink();
    isChild = false;
    showConfirmTicket: boolean = true;
    showConfirmButtons: boolean = true;
    appReference: string;
    ReservationResultIndex: string;
    ticketServerData: any;
    journeyListData: any;


    config: ExportAsConfig = {
        type: 'pdf',
        elementIdOrContent: 'print_voucher',
        options: {
            jsPDF: {
                orientation: 'portrait'
            },
            pdfCallbackFn: this.pdfCallbackFn // to add header and footer
        }

    };

    submitted: boolean;
    showPaymentDetails: boolean;
    paymentData: any;
    confirmation: any;
    orderId: any;


    constructor(
        private flightService: FlightService,
        private swalService: SwalService,
        private util: UtilityService,
        private apiHandlerService: ApiHandlerService,
        private exportAsService: ExportAsService,
        private activatedRoute: ActivatedRoute,
        private cdr: ChangeDetectorRef
    ) { }


    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe(params => {
            this.appReference = (params.AppReference).replace("/", "");
            this.orderId = params.OrderId ? (params.OrderId).replace("/", "") : "";
            this.confirmation = params.Confirmation ? (params.Confirmation).replace("/", "") : "";
            if (this.appReference && this.appReference != "") {
                let req = { 'AppReference': this.appReference }
                this.subSunk.sink = this.apiHandlerService.apiHandler('flightVoucher', 'post', '', '', req).subscribe(res => {
                    if (res) {
                        res.data[0]['FlightItineraries'].forEach((element, i) => {
                            if (element.attributes) {
                                let attributes = element.attributes.replace(/\"/gi, "\"");
                                res.data[0]['FlightItineraries'][i]['attributes'] = JSON.parse(attributes);
                            }
                        });
                        this.confirmedData = res.data[0];
                        if (this.confirmation && this.confirmedData.BookingStatus === 'BOOKING_HOLD' && this.appReference && this.orderId) {
                            this.checkPaymentStatus(this.confirmedData);
                        }
                        if (this.confirmedData.Passengers[0].ticket_no) {
                            this.showConfirmTicket = false;
                        }
                        this.airline_logo = this.flightService.airline_logo;
                        this.currentUser = this.util.readStorage('b2cUser', sessionStorage);
                        this.cdr.detectChanges();
                    }
                });
            } else {
                this.confirmedData = this.util.readStorage('ticketCache', sessionStorage);
                if (this.confirmedData.Passengers[0].ticket_no) {
                    this.showConfirmTicket = false;
                }
                this.airline_logo = this.flightService.airline_logo;
            }
        })
    }

    callPnrTicket(data) {
        console.log(data)
        let TicketData = {
            AppReference: data.AppReference,
            booking_source: data.ApiCode,
            order_id: this.orderId
        }
        this.flightService.loading.next(true);
        this.subSunk.sink = this.apiHandlerService.apiHandler('pnrRetrieve', 'post', '', '', TicketData)
            .subscribe(res => {
                if (res) {
                    
                    this.confirmedData.BookingStatus = res.data.FinalBooking.BookingDetails.BookingStatus;
                    let paxes = [];
                    res.data.FinalBooking.BookingDetails.PassengerDetails.forEach(element => {
                        let pax = {
                            first_name: element.FirstName,
                            id: element.PassengerId,
                            last_name: element.LastName,
                            passenger_type: element.PassengerType,
                            ticket_no: element.TicketNumber,
                            title: element.Title
                        }
                        paxes.push(pax);
                    });
                    this.confirmedData.Passengers = paxes;
                    console.log(this.confirmedData)
                    this.util.writeStorage("ticketCache", res.data.FinalBooking.BookingDetails, sessionStorage)
                    this.showConfirmTicket = false;
                    this.flightService.loading.next(false);
                    this.cdr.detectChanges();
                }
            }, (err => {
                this.swalService.alert.oops(err.error.Message);
                this.flightService.loading.next(false);
            })
            );
    }

    downloadA4(type: SupportedExtensions, orientation?: string): void {
        document.getElementById('download').style.display = "none";
        //document.getElementById('ticket').style.display = "none";
        window['html2canvas'] = html2canvas;
        const date = new Date().toDateString();
        const doc = new jsPDF({
            orientation: 'p',
            unit: 'pt',
            format: 'a4',
            // x: '0px',
            // y: '0px'
        });
        const content = this.print_voucher.nativeElement;
        doc.html(content, {
            html2canvas: {
                allowTaint: true,
                useCORS: true,
                scale: 600 / content.scrollWidth
            },
            callback: async (doc) => {
                doc.save(`${this.confirmedData['AppReference']}.pdf`);
                this.swalService.alert.success();
                document.getElementById('download').style.display = "inline-block";
               // document.getElementById('ticket').style.display = "inline-block";
                // if (!isWithPrice) {
                //     this.showPayment = !isWithPrice;
                // }
            }
        });

    }

    pdfCallbackFn(pdf: any) {
        // example to add page number as footer to every page of pdf
        const noOfPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= noOfPages; i++) {
            pdf.setPage(i);
            pdf.text('Page ' + i + ' of ' + noOfPages, pdf.internal.pageSize.getWidth() - 40, pdf.internal.pageSize.getHeight() - 5);
        }
    }


    duration(origin, destination) {
        const startDate = new Date(origin);
        // Do your operations
        const endDate = new Date(destination);
        const seconds = (endDate.getTime() - startDate.getTime()) / 1000;
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);

        return hours + ' hr ' + (minutes - (hours * 60)) + ' min';

    }

    getFormtedStatus(status: string) {
        if (status != null) {
            let tmpStatus = status.split('_');
            return `${tmpStatus[0] + ' ' + tmpStatus[1]}`;
        }
    }

    getBaggage(val) {
        if (val) {
            let bg = val.split(" ");
            if (bg.length > 1 && bg[1] != "undefined" && parseInt(bg[0]) > 0)
                return bg[0] + ' ' +
                    ((bg[1] == 'Kilograms' || bg[1] == 'Kg' || bg[1] == 'KGS') ? 'KG' : bg[1]);
            else
                return bg[0] + ' ' + 'KG';
        } else if (val === '') {
            return '0 KG';
        }
    }

    checkPaymentStatus(data) {
        let req = {
            app_reference: this.appReference,
            order_id: this.orderId
        }
        this.subSunk.sink = this.apiHandlerService.apiHandler('paymentConfirmation', 'post', {}, {},
            req).subscribe(resp => {
                if (resp.statusCode == 201 && resp.data) {
                    this.callPnrTicket(data);
                }
            })
    }

    public download(): void {
        this.showConfirmButtons = false;
        window.scrollTo(0, 0);
        var data = document.getElementById('print_voucher');

        setTimeout(() => {
            html2canvas(data, {
                allowTaint: true,
                useCORS: true
            }).then(canvas => {
                const contentDataURL = canvas.toDataURL('image/png', 1.0)
                let pdf = new jsPDF('p', 'mm', 'a4');
                const imgProps = pdf.getImageProperties(contentDataURL);
                var width = pdf.internal.pageSize.getWidth() - 3;
                var height = (imgProps.height * width) / imgProps.width;
                pdf.addImage(contentDataURL, 'PNG', 0, 0, width, height);
                this.swalService.alert.success();
                pdf.save(`${this.confirmedData['AppReference']}.pdf`);
                this.showConfirmButtons = true;
            });
        }, 1000)
    }

}
